module.exports = ".row:nth-child(odd){\r\n    background: #ececec;\r\n}\r\n\r\n.row{\r\n    padding:9px 0px 0px !important;\r\n}\r\n\r\n.error-msg{\r\n    color:red;\r\n    font-size:12px;\r\n    margin-top:3px;\r\n    display: block;\r\n  }\r\n\r\n.input-group label{\r\n    width:100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/registration/create-passwordph/create-passwordph.component.css
// module id = ./src/app/registration/create-passwordph/create-passwordph.component.css
// module chunks = main